module.exports = __webpack_public_path__ + "img/brick.95a92162.svg";